import { PHYSICS, VISUALS } from './config.ts';
import { Game, readOptions } from './app/Game.ts';
import { levelByIndex } from './levels/index.ts';

const canvas = document.getElementById('stage');
if (!(canvas instanceof HTMLCanvasElement)) throw new Error('Missing #stage canvas');

const game = new Game(canvas, readOptions());

try {
  await game.start();

  // Tuning handle. Every physics constant is meant to be a game-design knob, so make
  // them reachable without a rebuild: __magneto.PHYSICS.cohesion = 8000
  Object.assign(window as unknown as Record<string, unknown>, {
    __magneto: { game, PHYSICS, VISUALS, levelByIndex },
  });
} catch (error) {
  // A blank canvas tells the player nothing. Say what went wrong instead.
  console.error('[magneto] failed to start', error);
  const hint = document.getElementById('hint');
  if (hint) {
    hint.textContent =
      'This device could not start WebGL. Try a different browser, or reload the page.';
    hint.classList.remove('is-hidden');
  }
}
